import { TRIGGER } from "../actionTypes";

const initialState = {
    triggerOrder: false
};

export const globalReducer = (state = initialState, action) => {
    switch (action.type) {
        case TRIGGER:
            return { ...state, triggerOrder: !action.triggerOrder }
        default:
            return state;
    }
};
